export function ProIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3 4a1 1 0 000 2h18a1 1 0 100-2H3zm.707 4.292A1 1 0 002 9v6a1 1 0 102 0v-1.17a3 3 0 10-.293-5.537zM4 11a1 1 0 112 0 1 1 0 01-2 0zm6.707-2.708A1 1 0 009 9v6a1 1 0 102 0v-1.17c.177.062.362.108.553.137l1.74 1.74a1 1 0 001.414-1.414l-.899-.899a3 3 0 00-3.102-5.102zM11 11a1 1 0 112 0 1 1 0 01-2 0zm5 0a3 3 0 116 0v2a3 3 0 11-6 0v-2zm3-1a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zM2 19a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z"
      ></path>
    </svg>
  );
}
